import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import PublicLayout from "@/components/PublicLayout";
import ScrollToTop from "@/components/ScrollToTop";

import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CategoriesPage from "@/pages/CategoriesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import DealerPage from "@/pages/DealerPage";
import DaikinPage from "@/pages/DaikinPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

const withLayout = (Component) => (
  <PublicLayout>
    <Component />
  </PublicLayout>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={withLayout(HomePage)} />
            <Route path="/products" element={withLayout(ProductsPage)} />
            <Route path="/products/:id" element={withLayout(ProductDetailPage)} />
            <Route path="/categories" element={withLayout(CategoriesPage)} />
            <Route path="/about" element={withLayout(AboutPage)} />
            <Route path="/contact" element={withLayout(ContactPage)} />
            <Route path="/dealer" element={withLayout(DealerPage)} />
            <Route path="/daikin" element={withLayout(DaikinPage)} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/*" element={<AdminDashboardPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0f0f0f",
              border: "1px solid #262626",
              color: "#fff",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
